<template>
  <div style="width: 100%">
    <v-toolbar flat>
      <v-toolbar-title class="grey--text">Modificadores</v-toolbar-title>
      <v-spacer />
      <v-dialog v-model="dialog" max-width="900px" persistent>
        <template v-slot:activator="{ on }">
          <v-btn color="primary" dark class="mb-2" v-on="on">
            Nuevo modificador
          </v-btn>
        </template>
        <FormModificadores
          v-if="dialog"
          :item="editItem"
          @close="dialog = false"
          @save="saveItem"
        />
      </v-dialog>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="modificadores"
      :options.sync="options"
      class="elevation-1"
      :footer-props="{ itemsPerPageOptions: $root.OPTIONS_PER_PAGE_DATATABLE }"
      :loading="loading"
      :server-items-length="modificadoresTotal"
      :sort-by="'created_at'"
      :sort-desc="[false, true]"
      @update:options="listar"
    >
      <template v-slot:item.multiple="{ item }">
        <v-chip dark :class="{ teal: item.multiple, gray: !item.multiple }">
          {{ item.multiple ? "Sí" : "No" }}
        </v-chip>
      </template>
      <template v-slot:item.requerido="{ item }">
        <v-chip dark :class="{ teal: item.requerido, gray: !item.requerido }">
          {{ item.requerido ? "Sí" : "No" }}
        </v-chip>
      </template>
      <template v-slot:item.es_extra="{ item }">
        <v-chip dark :class="{ teal: item.es_extra, gray: !item.es_extra }">
          {{ item.es_extra ? "Sí" : "No" }}
        </v-chip>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              small
              v-on="on"
              color="light-blue darken-4"
              @click="editItemId(item.id)"
            >
              <v-icon small color="light-blue darken-4"> edit </v-icon>
            </v-btn>
          </template>
          <span>Editar Modificador</span>
        </v-tooltip>
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              small
              v-on="on"
              color="red"
              @click="deleteItemConfirm(item)"
            >
              <v-icon small color="red"> delete </v-icon>
            </v-btn>
          </template>
          <span>Eliminar modificador</span>
        </v-tooltip>
      </template>
    </v-data-table>
    <v-dialog v-model="dialog_delete" max-width="900px" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">Eliminar registro</span>
        </v-card-title>
        <v-card-actions>
          <v-spacer />
          <v-btn color="gray darken-1" @click="dialog_delete = false">
            No
          </v-btn>
          <v-btn
            color="red darken-1"
            class="white--text"
            :loading="loading_delete"
            :disabled="loading_delete"
            @click="deleteItem"
          >
            Si
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snackbar"
      rigth
      top
      :color="snackbar_config.color"
      :multi-line="snackbar_config.multi_line"
      :timeout="snackbar_config.timeout"
      :vertical="snackbar_config.mobile"
    >
      <div v-html="snackbar_config.text_content" />
      <v-btn dark @click="snackbar = false"> Cerrar </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import FormModificadores from "@components/FormModificadores";
import axios from "axios";

export default {
  name: "ModificadoresPage",
  components: {
    FormModificadores,
  },
  data() {
    return {
      dialog: false,
      dialog_delete: false,
      headers: [
        {
          text: "Nombre",
          align: "left",
          sortable: false,
          value: "nombre",
        },
        {
          text: "Orden",
          align: "left",
          sortable: true,
          value: "orden",
        },
        {
          text: "Multiple",
          align: "left",
          sortable: false,
          value: "multiple",
        },
        {
          text: "Requerido",
          align: "left",
          sortable: false,
          value: "requerido",
        },
        {
          text: "Máximo",
          align: "left",
          sortable: false,
          value: "maximo",
        },
        {
          text: "Es Extra",
          align: "left",
          sortable: false,
          value: "es_extra",
        },
        { text: "Opciones", value: "actions", sortable: false, width: "150px" },
      ],
      modificadores: [],
      modificadoresTotal: 0,
      itemSelectId: 0,
      itemDelete: null,
      loading: false,
      loading_delete: false,
      options: {
        descending: true,
        page: 1,
        itemsPerPage: this.$root.OPTIONS_PER_PAGE_DATATABLE[0],
        totalItems: 0,
      },
      snackbar: false,
      snackbar_config: {
        color: "",
        multi_line: false,
        timeout: 6000,
        mobile: false,
        text_content: "",
      },
    };
  },
  computed: {
    editItem() {
      if (this.itemSelectId) {
        return this.modificadores.find((item) => item.id === this.itemSelectId);
      } else {
        return {
          id: 0,
          nombre: "",
          activo: true,
        };
      }
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },
  methods: {
    close() {
      this.dialog = false;
      this.itemSelectId = 0;
    },
    editItemId(itemId) {
      this.itemSelectId = parseInt(itemId);
      this.dialog = true;
    },
    deleteItem() {
      this.loading_delete = true;
      axios
        .post("/api/modificador/eliminar/" + this.itemDelete.id)
        .then((response) => {
          this.loading_delete = false;
          let { data } = response;
          if (data.success) {
            this.snackbar_config.color = "success";
            this.snackbar_config.text_content = data.message;
            this.snackbar = true;
            this.itemDelete = null;
            this.dialog_delete = false;
            this.listar();
          }
        })
        .catch((error) => {
          this.loading_delete = false;
          this.snackbar_config.color = "error";
          if (error.response && error.response.data) {
            this.snackbar_config.text_content = error.response.data.message;
            this.snackbar = true;
          } else {
            this.snackbar_config.text_content = "Error durante la petición";
            this.snackbar = true;
          }
        });
    },
    deleteItemConfirm(item) {
      this.itemDelete = item;
      this.dialog_delete = true;
    },
    listar() {
      this.loading = true;
      let { sortBy, sortDesc, descending, page, itemsPerPage } = this.options;

      axios
        .get("/api/modificador/listar", {
          params: {
            sortBy: sortBy.toString(),
            sortDesc: sortDesc.slice(0, 1).toString(),
            descending: descending,
            page: page,
            rowsPerPage: itemsPerPage,
            search: this.search,
            familia_id: this.familiaId,
          },
        })
        .then((success) => {
          this.loading = false;
          let { data } = success;
          this.modificadores = data.data;
          this.modificadoresTotal = data.total;
          this.options.page = data.current_page;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    saveItem() {
      this.dialog = false;
      this.listar();
    },
  },
};
</script>

<style>
</style>